import { render, staticRenderFns } from "./DownloadPage.vue?vue&type=template&id=273fdb96&scoped=true&"
import script from "./DownloadPage.vue?vue&type=script&lang=js&"
export * from "./DownloadPage.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPage.vue?vue&type=style&index=0&id=273fdb96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273fdb96",
  null
  
)

export default component.exports